import { Box, Button, Typography, useTheme } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { useTranslation } from "react-i18next";

const EmptyState = ({
  title,
  description,
  actionLabel,
  onAction,
  icon = <InboxOutlinedIcon />,
  compact = false,
  prominent = false,
  secondaryAction,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const resolvedTitle = title || t("common.noData");

  return (
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        textAlign: "center",
        gap: prominent ? 2 : compact ? 0.5 : 1,
        px: 2,
        py: prominent ? 5 : compact ? 2.5 : 3,
        minHeight: prominent ? 300 : compact ? 112 : 152,
        color: "text.secondary",
        ...(prominent && { background: theme.custom.surface.inset, borderRadius: "16px", px: { xs: 2, md: 5 } }),
      }}
    >
      <Box sx={{ color: prominent ? "primary.main" : "text.secondary", display: "grid", placeItems: "center", mb: 0.5, width: prominent ? 64 : 40, height: prominent ? 64 : 40, borderRadius: prominent ? "20px" : "12px", bgcolor: "action.hover", border: "1px solid", borderColor: prominent ? "primary.main" : "divider", "& .MuiSvgIcon-root": { fontSize: prominent ? 30 : 24 } }}>{icon}</Box>
      <Typography variant={compact ? "body2" : "h6"} color="text.primary" fontWeight={700}>
        {resolvedTitle}
      </Typography>
      {description && <Typography variant={prominent ? "body1" : "body2"} color="text.secondary" sx={{ maxWidth: prominent ? 660 : 480 }}>{description}</Typography>}
      {((actionLabel && onAction) || secondaryAction) && <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" gap={1.5} mt={1}>
        {actionLabel && onAction && <Button size={prominent ? "medium" : "small"} variant="outlined" onClick={onAction} sx={prominent ? { bgcolor: "action.selected", borderColor: theme.palette.primary.main } : undefined}>{actionLabel}</Button>}
        {secondaryAction}
      </Box>}
    </Box>
  );
};

export default EmptyState;
